import { ReactNode } from 'react'
import { FetchStatus, UseQueryResult } from '@tanstack/react-query-v4'
import { Spinner } from '@components/ui/spinner/Spinner'

type QueryResultWrapperProps<TData> = {
  result: Pick<UseQueryResult<TData>, 'data' | 'error' | 'isLoading'> & {
    fetchStatus?: FetchStatus
  }
  children: ({ data }: { data: TData }) => ReactNode
  loadingView?: ReactNode
  errorView?: ReactNode
  noDataView?: ReactNode
  fullHeight?: boolean
}

export function QueryResultWrapper<TData>({
  result,
  loadingView = (
    <div className="flex justify-center">
      <Spinner />
    </div>
  ),
  children,
  errorView = <ErrorView />,
  noDataView = <></>,
  fullHeight,
}: QueryResultWrapperProps<TData>) {
  if (result.isLoading && result.fetchStatus !== 'idle' && !result.data) {
    if (fullHeight) {
      return (
        <div className="flex items-center justify-center h-[calc(100vh-5.5rem)]">
          {loadingView}
        </div>
      )
    }

    return loadingView
  }

  if (result.error) {
    console.error(result.error)
    return errorView
  }

  if (!result.data || (Array.isArray(result.data) && !result.data?.length)) {
    return noDataView
  }

  return <>{!!result.data && children({ data: result.data })}</>
}

const ErrorView = () => <div>Failed to load data.</div>
